

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs'
import { Link } from '@tanstack/react-router'

import { Fragment } from 'react'

export function Breadcrumbs() {
  const items = useBreadcrumbs()
  if (items.length === 0)
    return null

  const lastIndex = items.length - 1
  const lastItem = items[lastIndex]
  const containsDigit = (value?: string) => Boolean(value?.match(/\d/))
  const lastLinkSegment = lastItem?.link?.split('/').filter(Boolean).at(-1)
  const lastSegmentIsNumeric = Boolean(lastLinkSegment && /^\d+$/.test(lastLinkSegment))
  const shouldHideActivePage =
    Boolean(lastItem) && (containsDigit(lastItem.title) || lastSegmentIsNumeric)

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => (
          <Fragment key={item.title}>
            {index !== lastIndex && (
              <BreadcrumbItem className="hidden md:block">
                <BreadcrumbLink asChild>
                  <Link to={item.link}>{item.title}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
            )}
            {index < lastIndex && (
              <BreadcrumbSeparator className="hidden md:block" />
            )}
            {index === lastIndex && !shouldHideActivePage && (
              <BreadcrumbPage>{item.title}</BreadcrumbPage>
            )}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
